module.exports = __webpack_public_path__ + "static/media/very-good.ff27e598.svg";